<template>
  <div class="extra-menu-add-files">
    <span>{{ $t('general__data__files-associated') }}: </span>
    <div v-if="buttonsVisible">
      <input
        id="file"
        type="file"
        name="file"
        style="display: none"
        accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,audio/*,video/,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        @change="onChange"
      />
      <label for="file">
        <img
          v-if="canUpload"
          class="icon"
          src="@/assets/files/icon-add-extra-file.svg"
          alt=""
          data-test="file-list-header-button"
        />
      </label>
      <img
        v-if="canDownloadAndPreviewFile"
        class="icon"
        :class="{ disabled: !isFileSelected }"
        src="@/assets/files/icon-preview-file.svg"
        alt=""
        data-test="file-list-header-button"
        @click="
          () => {
            if (isFileSelected) emits('previewFile')
          }
        "
      />
      <img
        v-if="canUpload"
        class="icon"
        :class="{ disabled: !isFileSelected }"
        src="@/assets/files/icon-remove-extra-file.svg"
        alt=""
        data-test="file-list-header-button"
        @click="
          () => {
            if (isFileSelected) emits('removeFile')
          }
        "
      />
      <img
        v-if="canDownloadAndPreviewFile"
        class="icon"
        :class="{ disabled: !isFileSelected }"
        src="@/assets/files/icon-download-file.svg"
        alt="download file"
        data-test="file-list-header-button"
        @click="
          () => {
            if (isFileSelected) emits('downloadFile')
          }
        "
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { toRefs } from 'vue'

interface PROPS {
  buttonsVisible: boolean
  isFileSelected: boolean
  canDownloadAndPreviewFile: boolean
  canUpload: boolean
}
interface EMITS {
  (e: 'removeFile'): void
  (e: 'addFile', file: File): void
  (e: 'previewFile'): void
  (e: 'downloadFile'): void
}

const props = defineProps<PROPS>()
const emits = defineEmits<EMITS>()
const { buttonsVisible, isFileSelected, canDownloadAndPreviewFile, canUpload } = toRefs(props)

function onChange(event: Event) {
  const files = (event.target as HTMLInputElement).files
  if (!files) return
  emits('addFile', files[0])
}
</script>
<style scoped lang="scss">
.extra-menu-add-files {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.icon {
  padding-left: 10px;
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
}
</style>
